// Common
import { PopupMenuItem } from '$common/popup-menu'
import { BlockIcon } from '$common/icons/block'
import { RemoveChatIcon } from '$common/icons/remove-chat'
import { ClearHistoryIcon } from '$common/icons/clear-history'
import { AddUserIcon, EditOutlinedIcon } from '$common/icons'
import { ReportIcon } from '$common/icons/report'
import { RemoveIcon } from '$common/icons/remove'
// Localization
import { useAsyncFunction } from '$func/async-function.react-hook'
import { getPvByUserId } from '$logic/pv'
import { useUser } from '$logic/users'
import { t } from '$i18n'
import { blockUser, unBlockUser } from '$logic/user-policy'
import { openEditContact } from '$logic/router'
import {
  showClearPVHistory,
  showDeleteContactModal,
  showDeletePvModal,
} from '$comp/modals/confirmation-dialog'
import { showReportSendSnackbar } from '$comp/snackbars'
import { ContextMenuList } from '$comp/_app/components/chat/components/body/components/context-menu/components'

interface Props {
  userId: string
  onClose: () => unknown
  xAxis: number
  yAxis: number
}
export function ChatWithUserMenu({ userId, yAxis, xAxis, onClose }: Props) {
  const { user } = useUser(userId)
  const isContact = user?.isContact
  const isBLocked = user?.isBlocked
  const isDeleted = user?.deletedAt

  const onBlock = async () => {
    analite('BLOCK_USER', {
      active: true,
      source: 'USER_MENU',
    })
    await blockUser(userId)
    onClose()
  }
  const onUnBlock = async () => {
    analite('BLOCK_USER', { active: false, source: 'USER_MENU' })
    await unBlockUser(userId)
    onClose()
  }
  const onReport = async () => {
    onClose()
    showReportSendSnackbar()
    // TODO: Show report modal
  }

  const onAddToContacts = async () => {
    openEditContact(userId, true)
    onClose()
  }
  const onEditContact = async () => {
    openEditContact(userId)
    onClose()
  }
  const onDeleteContact = async () => {
    showDeleteContactModal(userId)
    onClose()
  }
  const onRemoveChat = async () => {
    showDeletePvModal(userId)
    onClose()
  }
  const onClearHistory = async () => {
    showClearPVHistory(userId)
    onClose()
  }

  const { value: hasPv } = useAsyncFunction(
    () => getPvByUserId(userId),
    [userId],
  )

  return (
    <ContextMenuList onClose={onClose} open xAxis={xAxis} yAxis={yAxis}>
      {!isBLocked ? (
        <PopupMenuItem text={t('profile.user.block')} onClick={onBlock}>
          <BlockIcon sx={{ color: 'secondary.main' }} />
        </PopupMenuItem>
      ) : (
        <PopupMenuItem text={t('profile.user.unblock')} onClick={onUnBlock}>
          <BlockIcon sx={{ color: 'secondary.main' }} />
        </PopupMenuItem>
      )}

      <PopupMenuItem text={t('menu.common.report')} onClick={onReport}>
        <ReportIcon />
      </PopupMenuItem>

      {isContact ? (
        <>
          <PopupMenuItem
            text={t('contacts.editContact')}
            onClick={onEditContact}
          >
            <EditOutlinedIcon sx={{ color: 'secondary.main' }} />
          </PopupMenuItem>

          <PopupMenuItem
            text={t('profile.user.deleteContact')}
            onClick={onDeleteContact}
          >
            <RemoveIcon />
          </PopupMenuItem>
        </>
      ) : undefined}

      {!isContact && !isDeleted && user?.phone ? (
        <PopupMenuItem
          text={t('profile.user.addToContacts')}
          onClick={onAddToContacts}
        >
          <AddUserIcon color="secondary" />
        </PopupMenuItem>
      ) : undefined}

      {hasPv && (
        <PopupMenuItem
          text={t('menu.common.removeChat')}
          onClick={onRemoveChat}
        >
          <RemoveChatIcon />
        </PopupMenuItem>
      )}

      {hasPv && (
        <PopupMenuItem
          text={t('menu.common.clearHistory')}
          onClick={onClearHistory}
        >
          <ClearHistoryIcon />
        </PopupMenuItem>
      )}
    </ContextMenuList>
  )
}
